"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutSection() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const storyLines = ["EcoLuxMaya was born from a passion for the Riviera Maya's natural wonders and cultural richness.", "We believe luxury and sustainability can coexist harmoniously, creating experiences that honor both the environment and discerning travelers.", "Every journey we curate is a celebration of Caribbean elegance, adventure, and authentic connection to this paradise.", "Join us in discovering the soul of the Riviera Maya through exclusive, eco-conscious experiences."];
  return <section id="about-section" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-accent py-24 px-6">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549040/img/palm_fronds_texture.png)] bg-cover bg-center opacity-10 pointer-events-none" aria-hidden="true" />

      {}
      <div className="relative z-10 max-w-2xl mx-auto text-center" ref={textRef}>
        {storyLines.map((line, i) => <p key={i} data-index={i} className={`font-display text-foreground-accent text-xl md:text-2xl leading-relaxed mb-8 transition-all duration-[var(--duration-slow)] ease-[var(--ease-spring)] ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        transitionDelay: textVisible ? `${i * 200}ms` : "0ms"
      }}>
            {line}
          </p>)}
      </div>
    </section>;
}